<!--
 * @Author: cryi.liu
 * @Date: 2020-05-14 13:38:51
 * @LastEditTime: 2020-06-14 10:57:46
 * @Description: 待编辑题目弹层
 -->
<template>
  <i-modal
    id="wait-edit-question-modal"
    :value="modal"
    :width="890"
    footer-hide
    @on-visible-change="modalStateChanged">
    <p slot="header" class="title">待编辑题目</p>
    <wait-edit-question-table :data="tableData" @repull-wait-edit-list="repullWaitEditList" />
    <wait-edit-question-page :total="total" :page="page" @index-change="pageIndexChanged" />
  </i-modal>
</template>

<script>
import WaitEditQuestionTable from './WaitEditQuestionTable.vue';
import WaitEditQuestionPage from './WaitEditQuestionPage.vue';

export default {
  name: 'WaitEditQuestionModal',
  components: {
    WaitEditQuestionTable,
    WaitEditQuestionPage,
  },
  props: {
    modal: { type: Boolean, required: true },
  },
  data() {
    return {
      tableData: [],
      total: 0,
      page: {
        index: 1,
        size: 5,
        count: 0,
      },
    };
  },
  watch: {
    modal(value) {
      if (value) {
        this.requestWaitEditQuestionAndSetting();
      }
    },
  },
  methods: {
    /**
     * 弹层显示状态发生改变
     */
    modalStateChanged(state) {
      if (!state) {
        this.$emit('close-modal');
      }
    },
    /**
     * 分页索引改变
     */
    pageIndexChanged(index) {
      this.page.index = index;

      this.requestWaitEditQuestionAndSetting();
    },
    /**
     * 重新获取待编辑题库题目列表
     */
    repullWaitEditList() {
      this.requestWaitEditQuestionAndSetting();
    },
    /**
     * 请求待编辑题目列表并设置
     */
    requestWaitEditQuestionAndSetting() {
      this.requestWaitEditQuestion()
        .then((result) => {
          /**
            * 后台如果没数据直接不返回字段
            * 做容错
            */
          if (!result.content) {
            result.content = [];
          }

          if (!result.count) {
            result.count = 0;
          }

          if (!result.pageCount) {
            result.pageCount = 0;
          }

          return result;
        })
        .then((result) => {
          const tableData = this.contentBracketTransformUnderline(result.content);
          this.tableData = tableData;
          return result;
        })
        .then((result) => {
          this.total = result.count;
          return result;
        })
        .then((result) => {
          this.page.index = result.pageIndex;
          this.page.count = result.pageCount;
        })
        .catch(() => {
        });
    },
    /**
     * 请求待编辑题目列表
     */
    requestWaitEditQuestion() {
      const params = {
        pageNumber: this.page.index,
        pageSize: this.page.size,
      };

      return new Promise(async (resolve, reject) => {
        const result = await this.$http.examcenter.libraryWaitEditList(params);

        if (result.success) {
          resolve(result.data);
        } else {
          reject(result);
        }
      });
    },
    /**
     * 填空题[]转__
     */
    contentBracketTransformUnderline(questions) {
      questions.forEach((question) => {
        if (question.questionType === '填空') {
          const content = question.content.replace(/\[\]/g, '__');

          question.content = content;
        }
      });

      return questions;
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .ivu-modal {
  .title {
    font-size: 12px;
    font-weight: bold;
  }

  .ivu-modal-body {
    padding: 6px 16px;
  }
}
</style>
